import { defineMessages } from 'react-intl';

export default defineMessages({
    RenewalDeclarationsHeader: {
        id: 'cep.components.sgRenewalDeclarationsPage.Header',
        defaultMessage: 'Your cover summary'
    },
    BreakdownBookletLink: {
        id: 'cep.components.sgRenewalDeclarationsPage.BreakdownBookletLink',
        defaultMessage: 'Breakdown Assistance policy book'
    },
    Continue: {
        id: 'cep.components.sgRenewalDeclarationsPage.Continue',
        defaultMessage: 'Accept'
    },
    Back: {
        id: 'cep.components.sgRenewalDeclarationsPage.Back',
        defaultMessage: 'Go back'
    },
    RenewalPageImportantAccept: {
        id: 'cep.components.sgRenewalDeclarationsPage.RenewalPageImportantAccept',
        defaultMessage: '<span>By clicking <b>Accept</b>, you confirm that you have read the above</span>'
    },
});
